<header class="bciti-dialog__header">
  <div class="bciti-dialog__title">
    {{ data.translatedValues.dialogTitle }}
  </div>
  <button class="bciti-dialog__close-button" (click)="close()">
    <span class="icon icon-close"></span>
  </button>
</header>
<div class="bciti-dialog__content">
  <div class="image" [style.background-image]="'url(' + imageUrl + ')'"></div>
  <div class="row">
    <div class="column">
      <div class="service-name">
        <span [ngStyle]="{ 'color': data.service?.override?.status?.color }">
          {{ serviceName }} {{ serviceOverrideName }}
        </span>
        <!-- <span [class]="'icon ' + getStarredClasses" (click)="onStarredClick(!data.service.starred)" ></span> -->
      </div>
      <div class="category">
        <span [class]="'icon ' + serviceCategory?.icon"></span>
        <span class="category-name">{{ serviceCategory?.name[translate.currentLang] }}</span>
      </div>
      <div class="location" *ngIf="addressString">
        <div class="icon">
          <span [ngClass]="Icon.MAP"></span>
        </div>
        <div class="address">
          <span class="address-name">{{ serviceName }}</span>
          <span class="address-street">{{ addressString }}</span>
        </div>
      </div>
      <div class="description">
        <p>{{ serviceDescription }}</p>
        <a *ngIf="data.service.link" [href]="data.service.link.url" target="_blank">{{ data.service.link.label[translate.currentLang] }}</a>
      </div>
    </div>
    <div class="column">
        <div class="hours-title">{{ data.translatedValues.operationHoursTitle }}</div>
        <div class="hours-table">
          <div class="header">
            {{firstDayOfWeek }} - {{lastDayOfWeek }}
          </div>
          <div class="days">
            <div class="day row" *ngFor="let dayListItem of formattedDayList">
                <div class="label">
                    {{ getFormattedDay(dayListItem.date) }}, {{ getFormattedDate(dayListItem.date) }}
                </div>
                <div class="schedules">
                  <div class="schedule" *ngFor="let i of dayListItem.hourList">
                      <span class="hours">{{ i.from | timeFormat}} - {{ i.to | timeFormat}}</span>
                  </div>
                  <div class="schedule" *ngIf="dayListItem.hourList.length === 0" >
                      <span class="closed" >{{ 'pages.services-state.dialogs.service-schedule-dialog.closed' | translate }}</span>
                  </div>
                </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>